// extracted by mini-css-extract-plugin
export default {"content":"LoadingDialog_content__A6KYQ","logo":"LoadingDialog_logo__7J9xD","tada":"LoadingDialog_tada__K0hCr"};